const ReductionStatus = {
  INEFFECTIVE: 'Ineffective',
  OUTPERFORMED: 'Outperformed',
  EFFECTIVE: 'Effective',
  UNDERPERFORMED: 'Underperformed',
  UNDETERMINED: 'Undetermined'
}; 

export default ReductionStatus;
